import React, { useState, useEffect, useRef, useMemo } from "react"
import { useQuery, useQueryClient } from "react-query"
import { fetchDeals } from "../../../services/main.service"
import Paginator from "../../composites/paginator"
import WithAuth from "../../hoc/with-auth"
import { LayoutWithSidebar } from "../../layouts/layout-with-sidebar.tsx"
import {
  Badge,
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Grid,
  GridItem,
  Button,
  Input,
  IconButton,
  Link as Clink,
} from "@chakra-ui/react"
import _ from "lodash"
import BlockedLoader from "../../composites/blocked-loader"
import DateRangePicker from "../../composites/date-range-picker"
import { AiOutlineSearch } from "react-icons/ai"
import { InputWrapper } from "../../composites"
import { ReactSelect } from "../../composites/select"
import { SelectSymbols } from "../../composites/select-symbols"
import { CSVLink, CSVDownload } from "react-csv"
import { AiOutlineDownload } from "react-icons/ai"
import App from "../../../App"
import { app } from "../../../config"
import { formatDate, formatSecondsToDate } from "../../../utils";
import {
  getAllAccounts,
  getAllOrders,
  getAllPositions,
  getAllSummaries,
} from "../../../services/crm.service";
import { AgGridReact } from "ag-grid-react";
import { da } from "date-fns/locale";
import { OrderTypeEnum } from "../../../enum/Order.ts";

const OrdersPage = () => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(["orders"], () => getAllOrders(), {
    refetchInterval: 4000,
  });

  const gridRef = useRef<any>(); // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row

  //   // login order symbol createdAt type volume orderPrice sl tp livePrice
  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Login", field: "login" },
    { headerName: "Order", field: "order" },
    { headerName: "Symbol", field: "symbol" },
    { headerName: "Time", field: "createdAt" },
    { headerName: "Type", field: "type" },
    {
      headerName: "Volume",
      field: "volume",
    },
    { headerName: "Sell Price", field: "sellPrice" },
    { headerName: "Order Price", field: "orderPrice" },
    { headerName: "Price S/L", field: "sl" },
    { headerName: "Price T/P", field: "tp" },
    { headerName: "Live Price", field: "livePrice" },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      // make every column editable
      editable: false,
      selectable: true,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
      // enable floating filters by default
      floatingFilter: true,
      // make columns resizable
      resizable: true,
      // disable cell data types
      cellDataType: false,
      sortable: true,
    }),
    []
  );

  const orders = useMemo(() => {
    let _orders: any[] = [];

    if (data?.data?.data?.length) {
      _orders = _.map(data?.data?.data, (_order) => {
        return {
          ..._order,
          // @ts-ignore
          volume: parseFloat(_order?.volume / 10000).toFixed(2),
          createdAt: formatSecondsToDate(_order?.createdAt),
          type: OrderTypeEnum[_order?.type],
          sellPrice: _order?.sellPrice?.toFixed(2),
          livePrice: _order?.livePrice?.toFixed(2),
          orderPrice: _order?.orderPrice?.toFixed(2),
        };
      });
    }

    return _orders;
  }, [data?.data?.data]);

  return (
    <>
      <div className="ag-grid-container">
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "calc(100vh - 100px)" }}
        >
          <AgGridReact
            suppressScrollOnNewData={true}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={orders ?? []} // Row Data for Rows
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            overlayNoRowsTemplate={
              isLoading ? "Loading orders..." : "No  orders found"
            }
          />
        </div>
      </div>
    </>
  );
};

export default OrdersPage
